module.exports = __webpack_public_path__ + "static/media/Sazia.d0db20ae.jpeg";